import Vue from 'vue'
import Router from 'vue-router'
import api from '../../helpers/api'
window.api = api
require('../../helpers/utils')

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Inicio',
      component: () => import('@/pages/Homepage')
    },
    {
      path: '/inicio-sesion',
      name: 'Iniciar Sesion',
      component: () => import('@/pages/Login'),
      beforeEnter: window.unsecureOnly
    },
    {
      path: '/registrarse/:token?',
      name: 'Registrarse',
      component: () => import('@/pages/Register'),
      beforeEnter: window.unsecureOnly
    },
    {
      path: '/recuperar',
      name: 'Recuperar',
      component: () => import('@/pages/RecoverPassword'),
      beforeEnter: window.unsecureOnly
    },
    {
      path: '/prensa',
      name: 'Prensa',
      component: () => import('@/pages/Prensa')
    },
    {
      path: '/contacto',
      name: 'Contacto',
      component: () => import('@/pages/Contacto')
    },
    {
      path: '/cotizador',
      name: 'Cotizador',
      component: () => import('@/pages/Cotizador')
    },
    {
      path: '/roller-estandar',
      name: 'Cotizar Roller Estándar',
      component: () => import('@/pages/Cotizador'),
      props: {
        initialProduct: 'roller-estandar'
      }
    },
    {
      path: '/roller',
      name: 'Cotizar Roller',
      component: () => import('@/pages/Cotizador'),
      props: {
        initialProduct: 'roller'
      }
    },
    {
      path: '/roller-doble',
      name: 'Cotizar Roller Doble',
      component: () => import('@/pages/Cotizador'),
      props: {
        initialProduct: 'roller-doble'
      }
    },
    {
      path: '/duo',
      name: 'Cotizar Duo',
      component: () => import('@/pages/Cotizador'),
      props: {
        initialProduct: 'duo'
      }
    },
    {
      path: '/bandas-verticales',
      name: 'Cotizar Bandas Verticales',
      component: () => import('@/pages/Cotizador'),
      props: {
        initialProduct: 'bandas-verticales'
      }
    },
    {
      path: '/cortinas-con-barral',
      name: 'Cotizar con Barral',
      component: () => import('@/pages/Cotizador'),
      props: {
        initialProduct: 'cortinas-con-barral'
      }
    },
    {
      path: '/mosquitera',
      name: 'Cotizar Mosquitera',
      component: () => import('@/pages/Cotizador'),
      props: {
        initialProduct: 'mosquitera'
      }
    },
    {
      path: '/mosquitera-enrollable',
      name: 'Cotizar Mosquitera Enrollable',
      component: () => import('@/pages/Cotizador'),
      props: {
        initialProduct: 'mosquitera-enrollable'
      }
    },
    {
      path: '/paneles-orientales',
      name: 'Cotizar Paneles Orientales',
      component: () => import('@/pages/Cotizador'),
      props: {
        initialProduct: 'paneles-orientales'
      }
    },
    {
      path: '/carrito',
      name: 'Carrito',
      component: () => import('@/pages/Cart'),
      // beforeEnter: window.secureOnly
    },
    {
      path: '/checkout',
      name: 'Checkout',
      component: () => import('@/pages/Checkout'),
      // beforeEnter: window.secureOnly
    },
    {
      path: '/cuenta',
      name: 'Cuenta',
      component: () => import('@/pages/Account'),
      beforeEnter: window.secureOnly
    },
    {
      path: '/productos',
      name: 'Productos',
      component: () => import('@/pages/Products')
    },
    {
      path: '/productos/:producto',
      name: 'Productos Detalle',
      component: () => import('@/pages/Products')
    },
    {
      path: '/terminos-y-condiciones',
      name: 'Términos y Condiciones',
      component: () => import('@/pages/Terms')
    },
    {
      path: '/faq',
      name: 'FAQs',
      component: () => import('@/pages/Faq')
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  document.body.classList.remove('fade-in')
  document.title = to.name + ' - Cortinas Online'
  setTimeout(_ => {
    document.body.classList.add('fade-in')
  }, 1000)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js